import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated")({
  // Only auth check - no data fetching
  // This reduces TTFB by removing server-side subscription fetch
  // Subscription data is now fetched client-side in individual routes
  beforeLoad: async ({ context, location }) => {
    const session = context.session;

    if (!session) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }

    // No data fetching - just return empty object
    return {};
  },

  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return <Outlet />;
}
